"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPopover = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./styles.css"));
var _widgetContext = require("../../context/widgetContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ErrorPopover = exports.ErrorPopover = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    placement,
    tooltipContent,
    wrapWith
  } = props;
  const {
    isDesktop,
    isMyHome
  } = React.useContext(_widgetContext.widgetContext);
  const isDesktopView = isDesktop && !isMyHome; // Для моего дома необхъодимо использовать мобильные компоненты

  return /*#__PURE__*/React.createElement(_uiKit.Popover, {
    open: Boolean(tooltipContent),
    content: /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames.default)(styles['error-container'], !isDesktopView && styles['mobile'])
    }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
      color: "current_color"
    }, tooltipContent)),
    placement: isDesktopView ? placement || 'bottom-start' : 'bottom-start',
    flip: false,
    preventOverflow: false
  }, wrapWith ? /*#__PURE__*/React.createElement(wrapWith, {
    ref
  }, children) : /*#__PURE__*/React.cloneElement(children, {
    ref
  }));
});
ErrorPopover.displayName = 'ErrorPopover';